import type { components } from "../../shared/api/generated";

// Types backend (source de vérité) — voir openapi.json schemas
// Montants en XOF entier. Statuts en SCREAMING_SNAKE_CASE.

export type Order             = components["schemas"]["Order"];
export type OrderItem         = components["schemas"]["OrderItem"];
export type DeliveryAddress   = components["schemas"]["DeliveryAddress"];

// Enums extraits des unions du schéma backend
export type OrderStatus            = NonNullable<Order["status"]>;
export type OrderItemValidationStatus = NonNullable<OrderItem["validation_status"]>;

// ─── Bouclier Qualité — vérification agent + approbation client (openapi v2) ──
// Sur le terrain, l'agent constate la DISPONIBILITÉ réelle de chaque article
// (`availability`), prend une photo (`photo_media_id`) et relève le prix réel
// (`actual_price`). Le client tranche ensuite via `client_approval`.
export type OrderItemAvailability   = NonNullable<OrderItem["availability"]>;
export type OrderItemClientApproval = NonNullable<OrderItem["client_approval"]>;

// Adresse de livraison spécifique à un article (lat/lng + libellé) — permet
// d'éclater les produits d'une même commande vers des points différents.
export type OrderItemDeliveryAddress = NonNullable<OrderItem["delivery_address"]>;

// ─── Lien Order ↔ Trip (course multi-arrêts) ─────────────────────────────────
// Une Order peut être l'étape d'une course : `trip_id` pointe alors vers le Trip
// parent et `trip_stop_index` donne sa position (0-based). Une commande standalone
// a `trip_id == null`.
//
// ⚠️ Le cycle de vie d'une commande-étape est piloté par le Trip (POST
// /trips/{id}/stops/{stopIndex}) — il ne faut PAS la transitionner via
// /orders/{id}/transition (conflit avec la cascade serveur du Trip).
export const isTripOrder = (order: Pick<Order, "trip_id">): boolean =>
  order.trip_id != null;

export const orderStopLabel = (order: Pick<Order, "trip_stop_index">): string =>
  `Arrêt ${(order.trip_stop_index ?? 0) + 1}`;
